import {baseRequest} from './base';

//获取banner列表
function list(params){
  let tempUrl = '/api/pcWeb/feedback/list';
  return baseRequest(tempUrl,'get',params);
}

//详情
function detail(params){
  let tempUrl = '/api/pcWeb/feedback/detail/'+params.id;
  return baseRequest(tempUrl,'get');
}

export default {
  list,detail
}
